<template>
    <div class="the_end">
      <div class="one">
        联系我们  @2018豪体体育HOTi  all  rights  reserved
      </div>
      <div class="two">
          <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=50019002502093" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img :src="beianIcon" style="float:left;"/><p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;display: none;">渝公网安备 50019002502093号</p></a>
      </div>
    </div>
</template>

<script>
  import {get, post} from '@/api/fetch.js';
  import url from '@/api/serviceAPI.config.js';
    export default {
      data(){
        return {
          beianIcon:require('@/assets/images/beian_icon.png')
        }
      },
      name: "",
      methods:{

      },
      created(){

      }
    }
</script>

<style type="text/scss" lang="scss" scoped>
  .the_end{
    width: 100%;
    height: 90px;
    background-color: #ececec;
    margin-top: 30px;
    text-align: center;
  }

  .two{
    color: #8f8f8f;
    font-size: 16px;
    line-height: 3px;
  }

  .one{
    line-height: 53px;
    color: #8f8f8f;
    font-size: 16px;
    padding-top: 10px;
  }

</style>



// WEBPACK FOOTER //
// src/components/common/footer.vue